import { z } from 'zod';
/**
 * The envelope every cursor-paginated Notable endpoint returns: the page of rows, the cursor that
 * fetches the next one, and a ready-made link carrying that cursor plus the caller's other query
 * parameters. `after` and `next` are both null on the last page.
 *
 * Cursor pagination is a house REST convention rather than any one service's contract — primary,
 * the ehr-export orchestrator, and the web client each spoke it from their own copy of the shape —
 * so it lives here, where a schema can reach a backend response and a browser-side parse alike.
 *
 * @example
 * ```typescript
 * const GetTicketsResponseSchema = CursorPaginatedResponseSchema(TicketSchema);
 * ```
 */
export function CursorPaginatedResponseSchema(itemSchema) {
    return z.object({
        data: z.array(itemSchema),
        meta: z.object({
            page: z.object({
                after: z.string().nullable().describe('Cursor for the next page, null on the last page'),
            }),
        }),
        links: z.object({
            next: z.string().nullable().describe('URL for the next page, null on the last page'),
        }),
    });
}
//# sourceMappingURL=cursorPagination.js.map